import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const doraMetricsPlugin = createPlugin({
  id: 'dora-metrics',
  routes: {
    root: rootRouteRef,
  },
});

export const DoraMetricsPage = doraMetricsPlugin.provide(
  createRoutableExtension({
    name: 'DoraMetricsPage',
    component: () =>
      import('./components/DoraMetricsPage').then(m => m.DoraMetricsPage),
    mountPoint: rootRouteRef,
  }),
);
